module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('strong', [_vm._v("Implosion!")])]), _vm._v(" "), _c('p', {
    staticClass: "cot"
  }, [_c('strong', [_vm._v("“T")]), _vm._v("hey want us to get off at that platform,” I told Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The platform’s abandoned,” Frank said. Sometimes Frank has this thing where he has to state what is totally obvious. “The train’s not stopping there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I double-checked the text that had just been zapped to my phone. “That’s where they want us to make the drop.” A new text appeared. I showed the message to Frank. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TICK-TOCK. TOBY DOESN’T HAVE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MUCH TIME.")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I couldn’t even see the section of old platform anymore. We’d already gone past it. Frank leaped up and headed for the back of our car, grabbing a couple of newspapers that had been left lying on the ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("seats. I was pretty sure I knew what he had planned. If I was right, I was very sure I wasn’t going to like it.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened the door and stepped out on the metal slats between the subway cars. “We’re going to have to jump.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Dude, I want to get the money to the kidnappers. But we have to be going seventy miles an hour. How are we supposed to walk back to that platform if we’re deceased?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s a curve coming up. The train will have to slow down, probably to about thirty,” Frank answered. He crumpled up some of the newspaper and stuffed it under his sweater sleeves to pad his elbows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He handed one of the newspapers to me, and I crumpled and stuffed sheets of it everywhere possible. I would have swallowed some if I thought that would protect me from possible internal injuries.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay, here it comes. We’re slowing down. Jump perpendicular to the train,” Frank advised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, you want me to jump "), _c('em', [_vm._v("away")]), _vm._v(" from the train, not toward it?” I muttered. I get kind of sarcastic when I’m freaked out of my head. But Frank was right. Toby’s kidnappers weren’t exactly patient. We didn’t have time to get to the next stop and work our way back.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The brakes squealed a little as the train slowed. ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Now or never,” said Frank. And he jumped.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I pressed my tongue to the roof of my mouth. I hate biting my tongue. Did a check for anything big and hard in my path—as well as I could in the darkness of the subway tunnel. Then crouched down, covered my head with my arms, and jumped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("Roll like a log")]), _vm._v(", I told myself in the second before the splat. It’s better to let your whole body absorb the impact instead of just one or two parts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("Wham!")]), _vm._v(" I guess I did the landing correctly, because every single inch of my body was feeling the pain. I staggered to my feet and sucked in a deep breath. “You survive?” Frank called to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah.” I walked toward him, pulling out my newspaper stuffing. He flicked on one of his thin, super-high-power flashlights. Standard ATAC issue. That’s American Teens Against Crime. Frank and I are two of the American teens. We’d been recruited to the agency because our dad helped found it. He figured—and he was right—that there are some situations where teenagers make the best undercover ops.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I like to think the ATAC talent scouts would have found us on their own. Frank and I do have a reputation in Bayport as amateur detectives.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Remind me to send an e-mail to ATAC asking them for crash-landing pads that can be instantly ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("inflated. And they should be no bigger than a dollar bill when flat.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank snorted. “Okay, James Bond.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You know what? Frank gets a little sarcastic too sometimes. Like when he’s bleeding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you all right?” I asked him. “There’s blood coming out of your mouth.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bit my tongue,” he answered as he led the way back to the old platform.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw the words "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCOLLY-BRATTLE LOOP")]), _vm._v(" painted on one of the walls. “Oh, man. I saw this special on albino underground dwellers, and the Scolly-Brattle loop is where they lived. They were albino because they’d lived down here for generations, ever since this cave-in. They’re supposed to have gills even, because it’s always so—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m getting you the Weemote,” Frank interrupted. “You clearly can’t handle viewing all the channels. I’m blocking everything but CNN and PBS.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That albino underground dwellers special was on PBS,” I told him. “Hey, there it is. The platform. At least they kept the juice on.” A row of steel-shaded lamps hung from the ceiling. They gave out some weak light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t see anybody,” said Frank. “Do they think we’re just going to drop the money without getting Toby first?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("That’s Toby Allison. Yeah, that Toby Allison. The skateboarding guru. Someone made an attempt to kidnap him a week ago, so ATAC assigned us to go undercover as part of his crew. There were always a bunch of skateboarders hanging out with Toby. The kidnappers managed to grab him again. Part of their demands was that the ransom be delivered by two members of Toby’s entourage. No cops. No FBI. Just kids who had been seen with Toby.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank and I made sure we were the kids who were going to do the ransom drop. But where were the kidnappers? And Toby?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hauled myself up onto the platform, wishing I’d left my newspaper stuffing in place. Frank climbed up next to me. I scanned the area. Cement floor. Red columns. An old pay phone. Benches. A couple of big wire trash cans. Some rats. No humans in sight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned in a slow circle. I wanted to make sure I hadn’t missed anything. Then the pay phone began to ring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s no way that thing should be working,” said Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I guess our kidnappers have some skillz,” I answered.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Frank picked up the phone. “We’re here,” he said into the receiver. He listened for a moment. “We’re ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("not leaving the money until we see Toby.” He listened for another moment, then turned to me. “Check your cell.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I pulled out the phone. It had a thin crack across the video screen, but it was working. “What am I looking for?” I asked Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before he could answer, a video clip began to play. A clip of me and Frank standing on the deserted platform. I lifted one hand in a wave. The little Joe on the screen did too. “We’re under live surveillance,” I told Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The screen went blank for a second, then a new image came up. Toby. Tied up inside a large, empty room. “Lee, Erik, it’s me.” Lee and Erik were Frank’s and my aliases for the mission. “It’s Friday at ten thirty-three. I’m okay. Just do whatever they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The camera on Toby pulled back. Back and back until we could see the outside of the ten-story building. And the street signs at the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’re saying the building is scheduled for demolition in ten minutes,” Frank said. “If we leave now, we’ll have time to get Toby out. They’ll unlock the door leading to the stairway out of here if they see us leave the cash.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I rushed over to the door. Tried it. Locked. “We have no way to know that they’re not messing with our heads.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I heard the sound of an explosion and jerked up my cell. A section of the building that Toby was being held in had just been blown away.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank and I looked at each other. He took off his backpack and unzipped it. He held it open wide, showing the stacks and stacks of hundred-dollar bills. Then he put the backpack down and joined me at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried it again. And it opened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hit speed dial 1 and got Vijay Patel on the phone as we took the stairs. Vijay handles a lot of the tech stuff for us when we’re in the field. He wants to be a field op himself, and I’m betting he will be pretty fast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Vijay, we need the fastest route from—” I checked the street signs and gave him our location and the location of the building where Toby was being held. Vijay rattled off directions, and Frank and I ran. Our feet were the fastest way there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The kidnappers were dead-on with the calculations. We raced up to the building eight and a half minutes later. That gave us a minute and a half to get Toby out of there. We should just be able to make it—but there definitely wasn’t any time to spare. The non-load-bearing walls had already been removed. That would make the building go down faster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let’s split up to do the search,” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll take—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("Bwam!")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The floor bucked underneath my feet, and my ears rang with the sound of the blast.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’ve started the demolition!” Frank yelled, choking on the cloud of dust the explosion had sent into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They never expected us to get Toby out!” I shouted back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That blast was localized. Just the bottom of the center row of columns, I think,” said Frank. “They should go for the bottom of the side columns next. Then somewhere near the tops of all the columns with the third blast.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If we were inside for the third blast, we’d be demolished along with the building. “I’ll go left, you go right,” I barked. Then I took off for the columns I knew had to be supporting my side of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With most of the walls gone, it wasn’t hard to find the columns I was looking for.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bore holes. That’s what I needed. Blasters drill holes into the cement of the columns and stuff them full of dynamite or other explosive stuff. When the combustible chemical or whatever the explosive is burns, it creates a huge amount of gas in a super-short amount of time. The pressure builds, then—"), _c('em', [_vm._v("kablam!")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("All right. There was one of those beautiful holes. Loops of yellow and green wire spilled out of it. I ran my fingers over them. They were cool.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Good sign. The wires were basically the fuse. The end of the wires would be surrounded by a small amount of explosive material. The heat from an electrical current running through the wires would cause a small explosion when it reached the material. And this would set off the primer charge that would set off the "), _c('em', [_vm._v("kablam")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I had to stop the heat. I pulled my Swiss Army knife out of my pocket. Cut the wires, stop the heat, right? I hoped so. I positioned the knife under a section of both the yellow and green wire, and cut them both at the same moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing exploded. I wasn’t positive nothing would explode, but there were two more columns with bore holes full of explosives to deal with. I dashed to the next column. Grabbed a yellow wire and a green wire. Hot. They were hot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bad sign. So bad. I slashed them. No "), _c('em', [_vm._v("kablam")]), _vm._v(". I took off toward the last column, and—you got it—"), _c('em', [_vm._v("kablam")]), _vm._v(". I was suddenly flying away from the column. Off my feet flying.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I hit the ground hard. "), _c('em', [_vm._v("I really should just wear padding at all times,")]), _vm._v(" I thought as small pieces of cement slammed into me like BBs from a BB gun. But at ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("least the building didn’t come crashing down on me.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I scrambled to my feet and saw Frank running toward me. “You saved two columns. Great. Me too. I don’t think we’re going to be able to get to the tops of the columns before they blow. Let’s just find Toby and hope what we did is enough to keep the building standing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hope. Yeah. I was hoping big-time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank and I found the stairs and took them as fast as we could. No Toby on the second floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We started for the third. "), _c('em', [_vm._v("Kablam!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The building rocked. It sounded like the tops of all the columns had been detonated together. But the bottoms of four of those columns were solid. They had to hold. Well, they didn’t really "), _c('em', [_vm._v("have")]), _vm._v(" to, but I figured the power of positive thinking couldn’t hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No Toby on the third floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No Toby on the fourth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the fifth, we heard him screaming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank untied his feet. I untied his hands. “Hope you’re as fast off a board as on,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He ran for the stairs. Good answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank and I were right behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hear the building groaning. "), _c('em', [_vm._v("Hold on a little longer")]), _vm._v(", I begged silently.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The building shuddered as we hit the second floor. "), _c('em', [_vm._v("Just a little longer.")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("We reached the first floor and tore out the front door. A few seconds later a cloud of dust surrounded us. The dust blinded me. It filled my nose and lungs, choking me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When it cleared, the building was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Imploded!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We were supposed to be under there,” Frank said, staring at the pile of rubble.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But we’re not,” I answered. I turned to Toby. “Any chance you can ID the people who snatched you? Since you’re alive and everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Toby grinned. “Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frank grinned too. “That means that the kidnappers better watch their backs. Starting right now.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363af731","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/003.vue
// module id = 63
// module chunks = 0